const loadImage = (source) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = reject;
  image.src = source;
});

const wrapLines = (context, text, maxWidth) => {
  const words = text.split(/\s+/);
  const lines = [];
  let line = "";
  words.forEach((word) => {
    const next = line ? `${line} ${word}` : word;
    if (context.measureText(next).width > maxWidth && line) { lines.push(line); line = word; }
    else line = next;
  });
  if (line) lines.push(line);
  return lines;
};

const drawLines = (context, lines, x, y, lineHeight) => lines.forEach((line, index) => context.fillText(line, x, y + index * lineHeight));

export const createMemoryCard = async (result) => {
  await document.fonts?.ready;
  const canvas = document.createElement("canvas");
  canvas.width = 1080; canvas.height = 1920;
  const context = canvas.getContext("2d");
  context.fillStyle = "#000"; context.fillRect(0, 0, 1080, 1920);
  const glow = context.createRadialGradient(830, 380, 10, 830, 380, 620);
  glow.addColorStop(0, "rgba(218,40,160,.28)"); glow.addColorStop(.45, "rgba(118,50,220,.14)"); glow.addColorStop(1, "rgba(0,0,0,0)");
  context.fillStyle = glow; context.fillRect(0, 0, 1080, 1080);
  const logo = await loadImage("/brand/humn-wordmark.png");
  context.drawImage(logo, 76, 72, 240, 69);
  context.fillStyle = "rgba(255,255,255,.56)"; context.font = "600 28px 'Outfit', sans-serif"; context.fillText("APPARENTLY I'M A", 76, 345);
  let titleSize = 150;
  let titleLines;
  while (titleSize > 90) {
    context.font = `800 ${titleSize}px 'Outfit', sans-serif`;
    titleLines = wrapLines(context, result.creator_type, 920);
    if (titleLines.length <= 3 && titleLines.every((line) => context.measureText(line).width <= 920)) break;
    titleSize -= 6;
  }
  context.fillStyle = "#fff"; context.textBaseline = "top"; drawLines(context, titleLines, 72, 395, titleSize + 8);
  const creatorY = 395 + titleLines.length * (titleSize + 8) + 8;
  context.fillStyle = "#ec4899"; context.font = "800 126px 'Outfit', sans-serif"; context.fillText("CREATOR.", 72, creatorY);
  context.fillStyle = "rgba(255,255,255,.8)"; context.font = "500 46px 'Outfit', sans-serif";
  const shareLines = wrapLines(context, result.share_line, 900).slice(0, 3); drawLines(context, shareLines, 76, creatorY + 220, 62);
  context.strokeStyle = "rgba(255,255,255,.16)"; context.beginPath(); context.moveTo(76, 1560); context.lineTo(1004, 1560); context.stroke();
  context.fillStyle = "#fff"; context.font = "600 38px 'Outfit', sans-serif"; context.fillText("What's your creator type?", 76, 1640);
  context.fillStyle = "rgba(255,255,255,.5)"; context.font = "500 30px 'Outfit', sans-serif"; context.fillText("humn-ai.club/memory", 76, 1780);
  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Could not create image")), "image/png"));
};

export const downloadMemoryCard = async (result) => {
  const blob = await createMemoryCard(result);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = `humn-${result.creator_type.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.png`; anchor.click();
  URL.revokeObjectURL(url);
};

export const shareMemoryCard = async (result) => {
  const blob = await createMemoryCard(result);
  const file = new File([blob], "my-humn-creator-type.png", { type: "image/png" });
  const text = `Apparently I'm a ${result.creator_type} Creator. ${result.share_line}`;
  if (navigator.share) {
    const payload = navigator.canShare?.({ files: [file] }) ? { title: "My HUMN Creator Type", text, url: window.location.href, files: [file] } : { title: "My HUMN Creator Type", text, url: window.location.href };
    await navigator.share(payload);
    return;
  }
  await downloadMemoryCard(result);
};